import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchBills, fetchBillSuccess } from "../../redux/action";
import { useNavigate, useLocation } from "react-router-dom";
import { formatFullDate } from "../../Utills/utils"
import "./bill.css";
import {
    // Redux imports
    updateOrderStatus,
    cancelOrder,
    fetchOrders,

} from "../../redux/orders/action";
import EmptyScreen from "../../component/common/EmptyScreen";
import Select from "react-select";
import { advancedBillingApi } from "../../services/advancedBillingApi";
import { toast } from "react-toastify";



const statusOptions = [
    { value: "", label: "All Status" },
    { value: "Paid", label: "Paid" },
    { value: "Void", label: "Void" },
    { value: "Draft", label: "Draft" },
    { value: "Refunded", label: "Refunded" },
    { value: "Partially Refunded", label: "Partially Refunded" },
];

const billFilterSelectStyles = {
    control: (base, state) => ({
        ...base,
        minHeight: "43px",
        height: "43px",
        backgroundColor: "var(--ui-surface)",
        borderColor: state.isFocused ? "var(--ui-primary)" : "var(--ui-border)",
        boxShadow: state.isFocused ? "0 0 0 1px var(--ui-primary)" : "none",
        "&:hover": { borderColor: state.isFocused ? "var(--ui-primary)" : "var(--ui-border)" },
    }),
    menu: (base) => ({
        ...base,
        overflow: "hidden",
        backgroundColor: "var(--ui-surface)",
        border: "1px solid var(--ui-border)",
        boxShadow: "var(--ui-shadow-raised)",
    }),
    menuList: (base) => ({ ...base, padding: 0 }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    option: (base, state) => ({
        ...base,
        backgroundColor: state.isSelected
            ? "var(--ui-primary)"
            : state.isFocused
                ? "var(--ui-surface-muted)"
                : "var(--ui-surface)",
        color: state.isSelected ? "var(--ui-on-primary)" : "var(--ui-text)",
        cursor: "pointer",
        ":active": { backgroundColor: "var(--ui-primary)", color: "var(--ui-on-primary)" },
    }),
    singleValue: (base) => ({ ...base, color: "var(--ui-text)" }),
    placeholder: (base) => ({ ...base, color: "var(--ui-text-muted)" }),
    dropdownIndicator: (base) => ({ ...base, color: "var(--ui-text-muted)" }),
    indicatorSeparator: () => ({ display: "none" }),
};

function Bills() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const billStatus = location.state?.billStatus;

    const [filter, setFilter] = useState("");
    const [search, setSearch] = useState("");
    const [selectedBill, setSelectedBill] = useState(null);
    const roleId = Number(JSON.parse(localStorage.getItem("admin_token_info") || "{}").roleId);

    console.log("billStatus", billStatus)
    const allBills = useSelector((state) => state?.admin.bills);

    const billDetails = billStatus === "Draft" ? allBills.filter((bill) => bill.billStatus === "Draft") : allBills;

    useEffect(() => {
        dispatch(fetchBills());
    }, [dispatch]);


    const handleUpdateOrderStatus = (orderId, newStatus) => {
        // updateOrderStatus(orderId, newStatus);
        dispatch(updateOrderStatus(orderId, newStatus));
    };

    const viewBill = (billId) => {
        const data = billDetails.find(b => b.billId === billId);
        dispatch(fetchBillSuccess(data))
        //dispatch({ type: SAVE_BILL_SUCCESS, payload: dto });
        navigate(`/bill/${billId}`);
    };

    const markPaid = (billId) => {
        const data = billDetails.find(b => b.billId === billId);
        dispatch(fetchBillSuccess(data))
        //dispatch({ type: SAVE_BILL_SUCCESS, payload: dto });
        //navigate(`/bill/${billId}`);
    };

    const voidBill = async bill => {
        const reason = window.prompt(`Reason for voiding bill ${bill.billNumber || ""}:`);
        if (!reason?.trim()) return;
        try {
            await advancedBillingApi.voidBill(bill.billId, reason);
            toast.success("Bill voided successfully");
            dispatch(fetchBills());
        } catch (error) { toast.error(error.message); }
    };


    const handleFetchOrders = () => {
        dispatch(fetchOrders());
    };

    const handleViewOrderDetails = (order) => {
        // viewBillDetails(order);
        dispatch(viewBillDetails(order));
    };

    const handleCloseDetails = () => {
        // closeDetails();
        dispatch(closeDetails());
    };

    // Filter and search logic
    const filteredbills = billDetails.filter((bill) => {
        const matchesFilter = filter ? bill.billStatus === filter : true;
        const billNo = `T-${bill.billNumber}`
        const matchesSearch =
            billNo.toLowerCase().includes(search.toLowerCase()) ||
            bill.tableNumber.toLowerCase().includes(search.toLowerCase()) ||
            bill.billStatus.toLowerCase().includes(search.toLowerCase()) ||
            formatFullDate(bill.createdAt).toLowerCase().includes(search.toLowerCase()) ||
            bill.grandTotal.toString().includes(search);
        return matchesFilter && matchesSearch;
    });

    // View order details
    const viewBillDetails = (order) => {
        setSelectedBill(order);
    };

    // Close details modal
    const closeDetails = () => {
        setSelectedBill(null);
    };

    return (
        <div className="notification-page">
            {/* Header */}
            <div className="notification-header">
                <h2>Bills</h2>
            </div>

            {/* Filters */}
            <div className="bill-filter-controls">
                <Select
                    inputId="bill-status-filter"
                    className="bill-status-filter"
                    classNamePrefix="bill-filter-select"
                    options={statusOptions}
                    value={statusOptions.find((option) => option.value === filter)}
                    onChange={(option) => setFilter(option?.value || "")}
                    isSearchable={false}
                    isDisabled={billStatus === "Draft"}
                    menuPortalTarget={document.body}
                    styles={billFilterSelectStyles}
                />
                <input
                    className="bill-search-filter"
                    type="text"
                    placeholder="Search orders..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                />
            </div>
            <div>
                {filteredbills.length > 0 ? (
                    filteredbills.map((bill) => (
                        <div
                            key={bill.billId}
                            className="bill-item-card"
                        >
                            <div className="bill-item-left">
                            {bill.billStatus !== "Draft" || bill.tokenNumber === null && (
                                <div>
                                    <strong>🎟️ Table Number:</strong> {bill.tableNumber}
                                </div>
                            )}

                            {bill.tokenNumber && (
                                <div>
                                    <strong>🎟️ Token Number:</strong> {bill.tokenNumber}
                                </div>
                            )}
                            <div>
                                <strong>🧾 Bill No.:</strong> {bill.billNumber}
                            </div>
                            <div>
                                <strong>
                                    {bill.billStatus === 'Paid' ? '✅' : bill.billStatus === 'Void' ? '❌' : '🕒'}
                                    Status:</strong> {bill.billStatus}
                            </div>
                            <div>
                                <strong>📅 Bill Payed Time:</strong> {formatFullDate(bill.createdAt)}
                            </div>
                            <div>
                                <strong>💰 Total Amount:</strong> {bill.grandTotal}
                            </div>
                            <div>
                                <strong>
                                    {bill.paymentMode === 'UPI' ? '📱' : bill.paymentMode === 'CARD' ? '💳' : '💵'}
                                    Payment Mode:</strong> {bill.paymentMode}
                            </div>

                        </div>
                        <div className="bill-item-right">
                            <button className="bill-action-btn btn-view-details" onClick={() => viewBillDetails(bill)}>
                                View Details
                            </button>

                            {bill.billStatus !== "Draft" && (
                                <button className="bill-action-btn btn-view-bill" onClick={() => viewBill(bill.billId)}> View Bill </button>
                            )}

                            {bill.billStatus === "Draft" && (
                                <button className="bill-action-btn btn-resume" onClick={() => navigate("/bill", { state: { billTaxDetails: bill } })}>
                                    Resume Bill
                                </button>
                            )}

                            {bill.billStatus === "PAYMENT_UNDER_REVIEW" && (
                                <button className="bill-action-btn btn-mark-paid" onClick={() => markPaid(bill.billId)}> Mark paid  </button>
                            )}
                            {[1, 2].includes(roleId) && !bill.isPaid && bill.billStatus !== "Void" && (
                                <button className="bill-action-btn btn-mark-paid" onClick={() => voidBill(bill)}>Void Bill</button>
                            )}
                        </div>
                    </div>
                )))
                    : <EmptyScreen message="No bills found for this restaurant." />
                }
            </div>
            {/* Order Details Modal */}
            {selectedBill && (
                <div
                    className="bill-details-modal"
                    onClick={closeDetails}
                >
                    <div
                        className="bill-details-content"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <h3>Bill Details</h3>
                        <div className="bill-details-row">
                            <strong>CGST Percent:</strong> <span>{selectedBill.cgstPercent || 0} %</span>
                        </div>
                        <div className="bill-details-row">
                            <strong>CGST Amount:</strong> <span>{selectedBill.cgstAmount}</span>
                        </div>
                        <div className="bill-details-row">
                            <strong>SGST Percent:</strong> <span>{selectedBill.sgstPercent || 0} %</span>
                        </div>
                        <div className="bill-details-row">
                            <strong>SGST Amount:</strong> <span>{selectedBill.sgstAmount}</span>
                        </div>
                        <div className="bill-details-row">
                            <strong>Service Charge Percent:</strong> <span>{selectedBill.serviceChargePercent || 0} %</span>
                        </div>
                        <div className="bill-details-row">
                            <strong>Service Charge Amount:</strong> <span>{selectedBill.serviceChargeAmount}</span>
                        </div>
                        <div className="bill-details-row">
                            <strong>Service Charge Applied:</strong> <span>{selectedBill.isServiceChargeApplied === true ? "Yes" : "No"}</span>
                        </div>
                        <div className="bill-details-row">
                            <strong>Discount Amount:</strong> <span>{selectedBill.discountAmount}</span>
                        </div>
                        <div className="bill-details-row">
                            <strong>Discount Type:</strong> <span>{selectedBill.discountType || "N/A"}</span>
                        </div>
                        <div className="bill-details-row">
                            <strong>Settlement Amount:</strong> <span>{selectedBill.settlementAmount}</span>
                        </div>
                        <div className="bill-details-row">
                            <strong>Change Return:</strong> <span>{selectedBill.changeReturn}</span>
                        </div>
                        <button className="bill-close-btn" onClick={closeDetails}>
                            Close
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Bills;
